import JsBarcode from 'jsbarcode'
import pdfMake from 'pdfmake/build/pdfmake'
import 'pdfmake/build/vfs_fonts'
import { formatDate } from '../../../utils/formatDate'

export function generateServiceOrderPDF({ numos, trans, product }) {
  function generateBarcode(data) {
    const canvas = document.createElement('canvas')

    JsBarcode(canvas, data, {
      format: 'CODE128',
      height: 40,
      displayValue: false,
    })

    return canvas.toDataURL('image/png')
  }

  const barcodeImage = generateBarcode(numos)

  const docDefinition = {
    pageSize: 'A4',
    header: [
      {
        text: `Impresso em ${formatDate(new Date(), "dd/MM/yyyy 'às' HH:mm")} por ${localStorage.username}`,
        alignment: 'right',
        fontSize: 8,
        margin: [10, 10],
      },
    ],
    content: [
      {
        text: `ESTORNO ORDEM DE SERVIÇO ${numos}`,
        style: 'titleOS',
      },
      {
        text: `Transação WMS: ${trans}`,
        style: 'descriptionOS',
      },
      {
        layout: 'headerLineOnly',
        table: {
          headerRows: 1,
          widths: [
            '*',
            'auto',
            '*',
            '*',
            '*',
            '*',
            '*',
            '*',
            '*',
            '*',
            '*',
            '*',
          ],
          body: [
            [
              { text: 'Cód.', style: 'tableRow' },
              { text: 'Descrição', style: 'tableRow' },
              { text: 'Rua O', style: 'tableRow' },
              { text: 'Préd. O', style: 'tableRow' },
              { text: 'Nvl O', style: 'tableRow' },
              { text: 'Apto O', style: 'tableRow' },
              { text: 'Qtd', style: 'tableRow' },
              { text: 'Rua D', style: 'tableRow' },
              { text: 'Préd. D', style: 'tableRow' },
              { text: 'Nvl D', style: 'tableRow' },
              { text: 'Apto D', style: 'tableRow' },
              { text: 'OK', style: 'tableRow' },
            ],
            [
              { text: product.sku, style: 'tableRow' },
              { text: product.descricao, style: 'tableRow' },
              { text: product.ruaorigem, style: 'tableRow' },
              { text: product.predioorigem, style: 'tableRow' },
              { text: product.nivelorigem, style: 'tableRow' },
              { text: product.aptoorigem, style: 'tableRow' },
              { text: product.qt, style: 'tableRow' },
              { text: product.ruadestino, style: 'tableRow' },
              { text: product.prediodestino, style: 'tableRow' },
              { text: product.niveldestino, style: 'tableRow' },
              { text: product.aptodestino, style: 'tableRow' },
              { text: '(   )', style: 'tableRow' },
            ],
          ],
        },
      },
      {
        text: `Nº O.S`,
        style: 'baseTextStrong',
      },
      {
        image: barcodeImage,
        width: 100,
        alignment: 'left',
      },
      {
        text: numos,
        style: 'baseText',
      },
    ],
    footer: [
      {
        text: '___________________________________',
        alignment: 'center',
      },
      {
        text: 'Assinatura do funcionário',
        style: 'employeeSignature',
      },
    ],
    styles: {
      baseText: {
        fontSize: 8,
      },
      baseTextStrong: {
        fontSize: 8,
        bold: true,
      },
      titleOS: {
        alignment: 'center',
        fontSize: 14,
        bold: true,
        marginBottom: 5,
      },
      descriptionOS: {
        alignment: 'center',
        fontSize: 8,
        marginBottom: 20,
      },
      tableRow: {
        fontSize: 8,
      },
      employeeSignature: {
        marginTop: 5,
        fontSize: 8,
        alignment: 'center',
      },
    },
  }

  pdfMake.createPdf(docDefinition).open()
}
